import ReactOnRails from 'react-on-rails';

import Home from '@components/pages/Home';

ReactOnRails.register({
  Home,
});
